/**
 * Generates a mixin that adds an `exportAsCsv` method to the component.
 * @param {Object|Function} options Options to pass to `exportDataAsCsv`. It can be an object or a factory function that returns an object.
 * @returns {Object} A Vue mixin
 * @example <caption>With object</caption>
 * ```js
 * exportable({ fileName: 'filename.csv' })
 * ```
 * @example <caption>With arrow function</caption>
 * ```js
 * exportable(({ fileName }) => ({ fileName }))
 * ```
 * @example <caption>With regular function</caption>
 * ```js
 * exportable(function () { return { fileName: this.fileName } })
 * ```
 */
export default (options = {}) => ({
  props: {
    exportable: {
      type: [Object, Function],
      default: () => options
    }
  },
  mounted () {
    const opts = typeof this.exportable === 'function'
      ? this.exportable(this) || {}
      : this.exportable

    this.$refs.dataTable.gridOptions.defaultCsvExportParams = {
      allColumns: false, // don't export hidden columns
      ...opts
    }
  },
  methods: {
    exportAsCsv () {
      this.$refs.dataTable.gridOptions.api.exportDataAsCsv()
    }
  }
})
